function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.833 83.333a2.095 2.095 0 01-1.475-.608 2.086 2.086 0 010-2.946l36.025-36.025L19.358 7.729a2.086 2.086 0 010-2.946 2.086 2.086 0 012.946 0l37.5 37.5a2.084 2.084 0 010 2.946l-37.5 37.5a2.074 2.074 0 01-1.475.608l.004-.004z",
  fillRule: "nonzero"
});

var SvgChevronRightinline = function SvgChevronRightinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgChevronRightinline;